import * as TYPES from '../../store/types'

const state = {
  users: [],
  metadata: {},
  readOnly: false,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.USERS_SET_DATA](st, obj) {
    if (obj.users) {
      st.users = obj.users
    }

    if (obj.metadata) {
      st.metadata = obj.metadata
    }

    st.readOnly = !!obj.readOnly
  },
}

const actions = {
  usersSetData({ commit }, obj) {
    commit(TYPES.USERS_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
